module.exports = __webpack_public_path__ + "static/Galanogrotesque-Semibold-7df9926b02bead3eb9430fad1216f229.woff";